<!--
 * @Author: 范向玲
 * @Date: 2022-12-06 15:39:08
 * @LastEditTime: 2024-05-31 13:26:01
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 走势库数据管理--详情表格
 * @FilePath: \web\src\components\PolicyManager\InformationManager\edit.vue
-->
<template>
  <section class="trend-edit-container">
    <a-form class="trend-edit-container" :model="formData" name="basic" ref="formRef" :rules="rules"
      :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-item label="资讯名称" name="name">
        <a-input v-model:value="formData.name" />
      </a-form-item>
      <a-form-item label="来源" name="source">
        <a-input v-model:value="formData.source" />
      </a-form-item>
      <a-form-item label="资讯地址" name="linkUrl">
        <a-input v-model:value="formData.linkUrl" />
      </a-form-item>
      <a-form-item label="资讯内容" name="content">
        <a-textarea v-model:value="formData.content" />
      </a-form-item>
      <a-form-item label="资讯时间" name="date">
        <a-date-picker v-model:value="formData.date" :valueFormat="'YYYY-MM-DD'" />
      </a-form-item>
      <a-form-item label="国内国际" name="type">
        <a-radio-group v-model:value="formData.type">
          <a-radio value='不区分'>不区分</a-radio>
          <a-radio value='国际'>国际</a-radio>
          <a-radio value='国内'>国内</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="图片" name="file">
        <a-upload v-model:file-list="fileList" :before-upload="beforeUpload" @remove="handleRemove" list-type="picture">
          <a-button>
            <upload-outlined></upload-outlined>
            上传图片
          </a-button>
        </a-upload>
        <span style="color:#B7A480">仅支持jpg、png、jpeg格式文件</span>

      </a-form-item>
      <!-- <a-form-item label="是否展示" name="shows">
        <a-radio-group v-model:value="formData.shows">
          <a-radio :value='0'>不展示</a-radio>
          <a-radio :value='1'>展示</a-radio>
        </a-radio-group>
      </a-form-item> -->
    </a-form>
  </section>
</template>

<script setup>

import { ref, watch, defineProps, defineExpose, } from 'vue';
import FileUpload from '@/components/lib/Upload/fileUploadImg.vue';


const props = defineProps({
  formState: {
    type: Object,
  },
  type: {
    type: String,
  },
  countryList: {
    type: Array,
  },
  mineList: {
    type: Array,
  },
});
const fileList = ref([]);


// let formData = JSON.parse(JSON.stringify(props.formState));
let formData = props.formState;

fileList.value = formData.img ? [
  {
    uid: '-1',
    name: '已上传图片',
    status: 'done',
    url: formData.img,
    thumbUrl: formData.img,
  },] : [];
/**
 * 点击导入报告
 */
const handleRemove = file => {
  const index = fileList.value.indexOf(file);
  const newFileList = fileList.value.slice();

  newFileList.splice(index, 1);
  fileList.value = newFileList;
};

const beforeUpload = file => {
  fileList.value = file;
  formData.fileList = fileList.value;
  return false;
};

const importFileList = (data) => {
  formData.fileList = data.fileList;
  formData.fileId = data.id;
};


const validateFile = (rule, value, callback) => {
  if (value) {
    if (formData.fileId) {
      callback();
    } else {
      callback(new Error('请上传文件！'));
    }
  } else {
    callback();
  }
};

const rules = {
  name: [{ required: true, message: '请输入资讯名称!', trigger: 'blur', },],
  source: [{ required: true, message: '请输入来源!', trigger: 'blur', },],
  linkUrl: [{ required: true, message: '请输入资讯地址!', trigger: 'blur', },],
  content: [{ required: true, message: '请输入资讯内容!', trigger: 'blur', },],
  date: [{ required: true, message: '请选择资讯时间!', trigger: 'change', },],
  type: [{ required: true, message: '请输入积分!', },],
  // file: [{ required: true, message: '请输入!', trigger: 'change', type: 'object', validator: validateFile },],
};


const formRef = ref();

defineExpose({ formRef, formData });

</script>

<style lang="scss">
.trend-edit-container {

  .ant-radio-wrapper {
    color: #fff;
  }

  .ant-form-item-label>label {
    color: #fff;
  }

  .ant-select {
    .ant-select-selector {
      padding: 0.1rem;
      background-color: transparent;
      border-color: #695933;
      font-size: 0.16rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: .43rem;
      height: .43rem;
      display: flex;
      align-items: center;
    }
  }

  .ant-calendar-picker {
    width: 100%;
  }
}
</style>
